import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PayPalButton } from "react-paypal-button-v2";
import { pago_registro } from './ConexionServidor';
import { notification } from 'antd';
import { Row, Col, Spin } from 'antd';

import '../assets/css/paypal.css';

import logo_paypal from '../assets/images/2024/titulos/ies_PagoIluminare.png';
import logo_paypal_en from '../assets/images/2024/titulos/Titulos_ENG/ies_PagoIluminare_ENG.png';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import pago_paypal from '../assets/images/2026/Logos-Botones/Boton_Paypal.png';
import pago_transferencia from '../assets/images/2026/Logos-Botones/Boton_Transferencia.png';

window.onbeforeunload = function () {
  window.scrollTo(0, 0);
}

const mensaje = (tipo, titulo, texto) => {
  notification[tipo]({
    message: titulo,
    description: texto,
  });
}

const PayPal = (props) => {

  const { datos } = props;

  //let datos = [0, 1220, 100,0,0,'USD'];
 //datos.pago = '100';
  const [pago_exitoso, setPagoExitoso] = useState(0);
  const [cargar_pantalla, setCargarPantalla] = useState(false);
  const [ver_tipo, setVerTipo] = useState(0);

  useEffect(() => {
    if (datos[2] === 0) {
      setPagoExitoso(1);
    }
  }, [datos]);

  const { idioma } = props;
  console.log(idioma);

  return (

    <>
      <Spin spinning={cargar_pantalla} delay={0}>
        <br /><br />
        {
          pago_exitoso === 0 ?

            <Row>
              <Col xs={{ span: 18, offset: 3 }} md={{ span: 12, offset: 6 }}>
                <br />
                <p className='titulo_seccion_2 inter'>Método de pago</p>
              </Col>
              <Col xs={{ span: 18, offset: 3 }} md={{ span: 14, offset: 5 }}>
                <hr className="line_paypal" />
              </Col>
              <Col span={24}>

                {idioma === 'es' ?
                  <p className="texto_paypal">
                    <strong>Por favor realiza el pago</strong>
                    <br />
                    Total (Impuestos incluidos):
                  </p>
                  :
                  <p className="texto_paypal">
                    <strong>Please make the payment</strong>
                    <br />
                    Total:
                  </p>}
                <p className="total_paypal">
                  <span>${new Intl.NumberFormat().format(datos[2])}<sup>{datos[4]}</sup></span>
                </p>
              </Col>
              
              {
                ver_tipo === 1 ?
                  <Col xs={{ span: 18, offset: 4 }} md={{ span: 10, offset: 7 }}>
                  
                  <p className='texto_transferencia'>
                  <strong>Beneficiario:</strong> IESNA, SECCIÓN CIUDAD DE MÉXICO, A.C.<br />
                  <strong>Banco:</strong> BBVA Bancomer<br />
                  <strong>N° de Cuenta:</strong> 0149931171<br />
                  <strong>CLABE:</strong> 012 180 00149931171 2<br />
                   <strong>Código SWIFT de BBVA Bancomer:</strong> BCMRMXMMPYM
                  <br /><br />
                  Envia el comprobante de pago junto con tu nombre completo y el correo con el que te registraste a los correos <a className='' href='mailto:enlace@iesmexico.org&subject=COMPROBANTE%20SEMINARIO%20DE%20ILUMINACION%202025&body=Nombre%3A%0ACorreo%20inscrito%3A' target='_blank'>enlace@iesmexico.org</a><br /><br />
                  </p>
                  <a className='btn_compobante' href='mailto:enlace@iesmexico.org&subject=COMPROBANTE%20SEMINARIO%20DE%20ILUMINACION%202026&body=Nombre%3A%0ACorreo%20inscrito%3A' target='_blank'>ENVIAR COMPROBANTE</a>
                  </Col>
                :
                (
                  ver_tipo === 2 ?
                    <Col xs={{ span: 18, offset: 4 }} md={{ span: 8, offset: 8 }}>
                  {idioma === 'es' ?
                      <p className="mini_texto_paypal">
                        Al hacer clic en "Paypal" sera dirigido a Paypal para completar el pago de manera mas segura.
                      </p>
                      :
                      <p className="mini_texto_paypal">
                        By clicking on "Checkout", you will be directed to PayPal to complete the payment safely.
                      </p>
                    }
                    <br />
                    <PayPalButton
                      style={{
                        layout: 'vertical',
                        color: 'blue',
                        shape: 'pill',
                        label: 'paypal'
                      }}
                      currency_code={datos[4]}
                      disable_funding='card'
                      createOrder={(data, actions) => {
                        return actions.order.create({
                          purchase_units: [{
                            amount: {
                              value: `${datos[2]}`
                            }
                          }],
                        });
                      }}
                      onApprove={(data, actions) => {
                        // Capture the funds from the transaction
                        return actions.order.capture().then(function (details) {
                          const pago = {
                            registro_id: datos[0],
                            orden: details,
                            estado: details.status
                          };

                          // OPTIONAL: Call your server to save the transaction
                          pago_registro(pago).then(({ status, data }) => {
                            switch (status) {
                              case 0:
                                switch (details.status) {
                                  case 'COMPLETED':
                                    mensaje('success', 'Registro completo', '');
                                    setPagoExitoso(1);
                                    break;
                                  default:
                                    mensaje('warning', 'Pago incompleto', '');
                                    setPagoExitoso(2);
                                    break;
                                }
                                break;
                              default:
                                mensaje('success', 'Registro incompleto', data);
                                break;
                            }
                          });
                        });
                      }}

                      options={{
                        clientId: "Ae0v7fdChsE99fhS7oLKaSEJAv3D6CYlNo_1iz53aobZDerwXzuT3sfgCjnjTfZpzshLIe4ezfZ_KqbZ",
                        currency: datos[4],
                        disableFunding: 'card'
                      }}
                    />
                  </Col>
              :
                <>
                  <Col xs={{span:20, offset:2}} md={{span:5, offset:7}}>
                    <img src={pago_paypal} style={{width:'100%', cursor:'pointer'}} onClick={()=>setVerTipo(2)} />
                  </Col>
                  <Col xs={{span:20, offset:2}} md={{span:5, offset:0}}>
                    <img src={pago_transferencia} style={{width:'100%', cursor:'pointer'}}  onClick={()=>setVerTipo(1)} />
                  </Col>
                </>
              )
              }
              
            </Row>

            :
            pago_exitoso === 1 ?

              <Row>
                <Col xs={{ span: 24, offset: 0 }} md={{ span: 18, offset: 3 }} >
                  <Row>
                    <Col span={0}>
                      <br /><br />
                    </Col>
                    <Col span={24}>
                      <p className="contenedor_registro_exitoso registro_exitoso">
                        {idioma === 'es' ?
                          <><strong>REGISTRO EXITOSO</strong> <CheckCircleOutlined style={{ color: '#1fa264' }} /></>
                          :
                          <strong>SUCCESSFUL REGISTRATION</strong>
                        }
                      </p>
                    </Col>
                    <Col span={24}><br />
                      {idioma === 'es' ?
                        <p className="texto_registro_exitoso">
                          En breve recibirá un correo de confirmación a la siguiente dirección:
                          <br />
                          <strong>{datos[3]}</strong>
                        </p>
                        :
                        <p className="texto_registro_exitoso">
                          You will shortly receive a confirmation email to the following address:
                          <br />
                          <strong>{datos[3]}</strong>
                        </p>}
                      {idioma === 'es' ?
                        <p className="texto_registro_exitoso color_azul_oscuro">
                          Si no encuentra el mail confirmación en su bandeja de entrada, es posible el mensaje<br />
                          haya sido enviado a la carpeta de SPAM / NO DESEADOS.<br /><br />
                          <small>*No se incluye servicio de Lunch</small>
                        </p>
                        :
                        <p className="texto_registro_exitoso color_azul_oscuro">
                          If you cannot find the confirmation email in your inbox, it is possible the message <br />has been sent to the SPAM / UNWANTED folder.
                        </p>}
                        <br />
                        <a href='/#agenda' className='bnt_ver_agenda'>VER AGENDA</a>
                        </Col>
                  </Row>
                </Col>
              </Row>
              :

              <Row>
                <Col xs={{ span: 18, offset: 3 }} md={{ span: 14, offset: 5 }}>

                </Col>
                <Col span={18} offset={3}>
                  <Row>


                    <Col span={24}>
                      <p className="registro_exitoso">
                        {idioma === 'es' ?
                          <strong>PAGO RECHAZADO <CloseCircleOutlined style={{ color: 'red' }} /></strong>
                          :
                          <strong>PAYMENT DECLINED <CloseCircleOutlined /></strong>}
                      </p>
                      <hr className="line_paypal_rechazado" />
                      {idioma === 'es' ?
                        <p className="texto_registro_exitoso">
                          Hubo un error al procesar su pago.
                          <br />
                          Por favor contáctese con el banco emisor de su tarjeta.
                        </p>
                        :
                        <p className="texto_registro_exitoso">
                          There was an error processing your payment.
                          <br />
                          Please contact the bank that issued your card.
                        </p>}
                      {idioma === 'es' ?
                        <Link to="/" className="boton_inicio">
                          VOLVER AL INICIO
                        </Link>
                        :
                        <Link to="/" className="boton_inicio">
                          BACK TO HOME
                        </Link>}
                    </Col>
                  </Row>
                </Col>
              </Row>


        }
        <br /><br /><br />
      </Spin>
    </>



  );

}

export default PayPal;